if (!customElements.get('results-timeline')) {
  class ResultsTimeline extends HTMLElement {
    constructor() {
      super();
      this.onTabClick = this.onTabClick.bind(this);
    }

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.results-timeline__tab'));
      this.panels = Array.from(this.querySelectorAll('.results-timeline__panel'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.onTabClick);
      });

      this.addEventListener('keydown', (event) => {
        if (!['ArrowRight', 'ArrowLeft'].includes(event.key)) return;
        const currentIndex = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        let nextIndex = currentIndex;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        this.activate(nextIndex);
        this.tabs[nextIndex].focus();
      });
    }

    onTabClick(event) {
      const index = Number(event.currentTarget.dataset.index);
      this.activate(index);
    }

    activate(index) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.classList.toggle('results-timeline__tab--active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.panels.forEach((panel, i) => {
        const active = i === index;
        panel.classList.toggle('results-timeline__panel--active', active);
        if (active) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }
  }

  customElements.define('results-timeline', ResultsTimeline);
}
